module.exports = {
    expired_1: "Liên kết đã hết hạn",
    limit_time: "Ưu đãi thời gian giới hạn cho ",
    participate: "Tham gia sự kiện đánh giá ngay để nhận phần thưởng độc quyền của bạn!",
    exclusive: "Độc quyền",
    reward: "Phần thưởng",
    token: "Tokens",
    vip: "Ngày VIP",
    after_completing: "Sau khi hoàn thành đánh giá và xác minh ảnh chụp màn hình, bạn sẽ nhận được",
    step_1: "<strong style='color: #000000'>Nhấp vào nút bên dưới</strong> để truy cập cửa hàng ứng dụng và <strong style='color: #000000'>để lại đánh giá 5 sao.</strong>",
    step_2: "Sau khi hoàn thành đánh giá, vui lòng <strong style='color: #000000'>chụp ảnh màn hình</strong> nội dung đánh giá của bạn.",
    step_3: "<strong style='color: #000000'>Tải lên ảnh chụp màn hình</strong> bên dưới và gửi ID trong ứng dụng của bạn để nhận phần thưởng.",
    click_to: "1. Nhấp để đi đến ",
    upload: "2. Tải lên Ảnh chụp màn hình Đánh giá",
    app_store: "App Store",
    google_play: "Google Play",
    go_to: "Đi đến ",
    example: "Ví dụ ảnh chụp màn hình",
    upload_screenshot: "Tải lên Ảnh chụp màn hình",
    claim: "Nhận Thưởng",
    verification_inprogress: "Cảm ơn bạn đã tải lên. Ảnh chụp màn hình của bạn đang được xem xét nhanh nhất có thể. Vui lòng kiên nhẫn.",
    verification_success: "Chúc mừng! <br/><br/> Bạn đã nhận phần thưởng thành công. Phần thưởng sẽ được chuyển vào tài khoản của bạn <strong>trong vòng 24 giờ.</strong> Vui lòng chú ý theo dõi. <br/><br/> Nếu bạn có bất kỳ câu hỏi nào, đừng ngần ngại liên hệ với bộ phận hỗ trợ khách hàng.",
    verification_failed: "Ảnh chụp màn hình đánh giá phải đáp ứng các điều kiện sau: <br/><br/> <div style='margin-left: 6px'> 1.Đánh giá phải là 5 sao và nội dung phải tích cực. <br/><br/> 2.Đánh giá phải được thực hiện trên <strong> Apple App Store hoặc Google Play Store. </strong> <br/><br/> 3.Ảnh chụp màn hình phải hiển thị đầy đủ nội dung đánh giá, bao gồm <strong> hình đại diện, tên người dùng và văn bản đánh giá. <strong></div>",
    reupload: "Tải lên lại"
}